import React, { useEffect, useState } from "react";
import "./ElectronWindowDragStrip.css";

const SHELL_CLASS = "starmesh-electron-shell";

/**
 * True in the macOS Electron shell, where the native title bar is hidden so
 * the window can only be moved by a CSS `-webkit-app-region: drag` surface.
 *
 * @returns {boolean}
 * @example
 * isElectronDarwinShell();
 * // true in the Mac desktop app, false in a browser or on Windows/Linux
 */
export const isElectronDarwinShell = () =>
  Boolean(
    typeof window !== "undefined" &&
      window.starmeshDesktop?.isElectron &&
      window.starmeshDesktop?.platform === "darwin"
  );

/**
 * App-wide fallback drag handle: a thin invisible strip across the top of the
 * window so screens that do not use the business layout (sign-in, onboarding,
 * loading) can still be moved. Must be rendered BEFORE the routed content:
 * Electron builds the drag region in DOM order and a later no-drag control
 * (every button/link/input, see ElectronWindowDragStrip.css) subtracts from it.
 *
 * @example
 * <ElectronWindowDragStrip />
 * // Renders nothing outside the macOS desktop app
 */
const ElectronWindowDragStrip = () => {
  const [enabled] = useState(() => isElectronDarwinShell());

  useEffect(() => {
    if (!enabled) return undefined;
    document.documentElement.classList.add(SHELL_CLASS);
    return () => {
      document.documentElement.classList.remove(SHELL_CLASS);
    };
  }, [enabled]);

  if (!enabled) return null;
  return <div className="electron-window-drag-strip" aria-hidden="true" />;
};

export default ElectronWindowDragStrip;
